import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatterClientRelationship } from '@models/matter';
import { CollectionPaths } from '@models/collections';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface SaleClientPathParams {
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class SaleClientsRepoService extends Repo<
	MatterClientRelationship,
	SaleClientPathParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: SaleClientPathParams): string {
		return CollectionPaths.business_matter_clients(
			this.businessId,
			pathParams.matterId,
		);
	}
}
